<script setup lang="ts">
import { T } from '@tolgee/vue'
import { watch } from 'vue'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'

const props = defineProps<{
  show: boolean,
  entries: number,
}>()

watch(() => props.show, show => {
  if (show) {
    document.body.classList.add('!overflow-hidden')
  } else {
    document.body.classList.remove('!overflow-hidden')
  }
}, { immediate: true })

</script>
<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="show"
      class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 bg-dark-most-bottom-layer/[.65] backdrop-blur-[4px] flex flex-col z-[800]"
    >
      <CrossCircleIcon class="w-6 h-6 min-w-[24px] absolute top-3 right-3 text-white/[87%]" />
      <div class="h-full w-full flex-1 flex flex-col gap-y-8 items-center justify-center relative">
        <div
          class="absolute w-[334px] h-[334px] rounded-full bg-green-primary/[.54] blur-[150px] -z-[1]"
        />
        <img
          class="w-[160px] h-auto object-cover"
          src="@/partners/lingo/lingo-giveaway/assets/images/ticket.png"
        >
        <div class="flex flex-col w-full gap-y-3 justify-center items-center px-[28.5px]">
          <h1 class="text-white text-[36px] font-bold leading-[42px] text-center whitespace-pre-line">
            <T
              key-name="lingo.giveaway.overlay.transaction.title"
              :default-value="`You have earned\n{count, plural, one {# entry} other {# entries}}`"
              :params="{count: entries}"
            />
          </h1>
          <p class="whitespace-pre-line text-center text-base font-medium tracking-tight text-solid-white">
            <T
              key-name="lingo.giveaway.overlay.transaction.description"
              :default-value="`You’re in the draw for today’s daily prize! \nGood luck!`"
            />
          </p>
        </div>
      </div>
    </div>
  </Transition>
</template>